<template>
  <div class="liveItem">
    <MobileHead />
    <div class="liveContent">
      <div class="main">
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }" class="home">{{ $t('navbar.home') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('navbar.live') }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="search">
          <p>{{ $t('navbar.live') }}</p>
        </div>
      </div>
      <div class="tab">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('live.tab1')" name="first">
            <!-- 直播内容框 -->
            <div class="live-box">
              <div class="item" v-for="(item, index) in liveDate" :key="index" @click="liveDetail(item)">
                <div class="vedio">
                  <img
                    :src="item.collectStatus ? require('../../../static/collent_yello.png') : require('../../../static/collent.png')"
                    @click.stop="toggle(item)"
                    class="shoucang"
                    alt=""
                  />
                  <img :src="item.coverPhoto" class="fengmian" alt="" v-if="item.coverPhoto.substr(0,4)=='http'"/>
                  <img :src="baseUrl + item.coverPhoto" class="fengmian" alt="" v-else/>
                  <!-- <div class="fixed">
                    <div class="banner-btn">
                      <img src="../../../static/ico_vedio.png" alt="" />
                    </div>
                  </div> -->
                </div>
                <div class="title">
                  <p>{{ item.liveCn }}</p>
                  <div class="title_icon">
                    <div class="img"><img src="../../../static/ico-time.png" alt="" /></div>
                    <span class="txt"> {{ item.startDate }}{{ $t('common.mobileLive') }} </span>
                  </div>
                </div>
                <div class="down">
                  <p>{{ item.exhibitorNameCn }}</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('live.tab2')" name="second">
            <!-- 直播内容框 -->
            <div class="live-box">
              <div class="item" v-for="(item, index) in liveDate" :key="index" @click="liveDetail(item)">
                <div class="vedio">
                  <img
                    :src="item.collectStatus ? require('../../../static/collent_yello.png') : require('../../../static/collent.png')"
                    @click.stop="toggle(item)"
                    class="shoucang"
                    alt=""
                  />

                  <img :src="item.coverPhoto" class="fengmian" alt="" v-if="item.coverPhoto.substr(0,4)=='http'"/>
                  <img :src="baseUrl + item.coverPhoto" class="fengmian" alt="" v-else/>
                  <!-- <div class="fixed">
                    <div class="banner-btn">
                      <img src="../../../static/ico_vedio.png" alt="" />
                    </div>
                  </div> -->
                </div>
                <div class="title">
                  <p>{{ item.liveCn }}</p>
                  <div class="title_icon">
                    <div class="img"><img src="../../../static/ico-time.png" alt="" /></div>
                    <span class="txt"> {{ item.startDate }}{{ $t('common.mobileLive') }} </span>
                  </div>
                </div>
                <div class="down">
                  <p>{{ item.exhibitorNameCn }}</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('live.tab3')" name="third">
            <!-- 直播内容框 -->
            <div class="live-box">
              <div class="item" v-for="(item, index) in liveDate" :key="index" @click="liveDetail(item)">
                <div class="vedio">
                  <img
                    :src="item.collectStatus ? require('../../../static/collent_yello.png') : require('../../../static/collent.png')"
                    @click.stop="toggle(item)"
                    class="shoucang"
                    alt=""
                  />
                  <img :src="item.coverPhoto" class="fengmian" alt="" v-if="item.coverPhoto.substr(0,4)=='http'"/>
                  <img :src="baseUrl + item.coverPhoto" class="fengmian" alt="" v-else/>
                  <!-- <div class="fixed">
                    <div class="banner-btn">
                      <img src="../../../static/ico_vedio.png" alt="" />
                    </div>
                  </div> -->
                </div>
                <div class="title">
                  <p>{{ item.liveCn }}</p>
                  <div class="title_icon">
                    <div class="img"><img src="../../../static/ico-time.png" alt="" /></div>
                    <span class="txt"> {{ item.startDate }}{{ $t('common.mobileLive') }} </span>
                  </div>
                </div>
                <div class="down">
                  <p>{{ item.exhibitorNameCn }}</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('live.tab4')" name="four">
            <!-- 直播内容框 -->
            <div class="live-box">
              <div class="item" v-for="(item, index) in liveDate" :key="index" @click="liveDetail(item)">
                <div class="vedio">
                  <img
                    :src="item.collectStatus ? require('../../../static/collent_yello.png') : require('../../../static/collent.png')"
                    @click.stop="toggle(item)"
                    class="shoucang"
                    alt=""
                  />
                  <img :src="item.coverPhoto" class="fengmian" alt="" v-if="item.coverPhoto.substr(0,4)=='http'"/>
                  <img :src="baseUrl + item.coverPhoto" class="fengmian" alt="" v-else/>
                  <!-- <div class="fixed">
                    <div class="banner-btn">
                      <img src="../../../static/ico_vedio.png" alt="" />
                    </div>
                  </div> -->
                </div>
                <div class="title">
                  <p>{{ item.liveCn }}</p>
                  <div class="title_icon">
                    <div class="img"><img src="../../../static/ico-time.png" alt="" /></div>
                    <span class="txt"> {{ item.startDate }}{{ $t('common.mobileLive') }} </span>
                  </div>
                </div>
                <div class="down">
                  <p>{{ item.exhibitorNameCn }}</p>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!--分页 -->
        <div class="pagination">
          <el-pagination
            v-if="pageshow"
            class="explore_right_pages"
            layout="prev, pager, next"
            :background="isBackground"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="16"
            :total="total1"
          >
          </el-pagination>
        </div>
        <!-- alert 弹框 -->
        <!-- <div class="alert_mess" v-show="visible">
          <div @click="closePhoto" class="closePhoto">
            <img class="close" src="../../../static/close.png" />
          </div>
          <div class="qrcode">
            <img :src="baseUrl + livePhoto" alt="" />
          </div>
          <div class="tip">{{ $t('live.tip') }}</div>
        </div> -->
        <div class="alert_mess" v-show="visible">
          <img class="close" @click="close" src="../../../static/close.png" />
          <div class="qrcode">
            <img :src="baseUrl + livePhoto" alt="" />
          </div>
          <div class="tip">{{ $t('live.tip') }}</div>
        </div>
      </div>
    </div>
    <Foot />
    <GoLogin :dialogVisible.sync="dialogVisible" v-if="dialogVisible" @func="getMsgFormSon" @funcancel="getCancel" />
  </div>
</template>

<script>
import MobileHead from '../../../common/mobile/head.vue';
import { getLiveInfo, getShoucang } from '../../../../api/livePage';
import { forMat } from '../../../../utils/common';
import Foot from '../../../common/mobile/footBottom.vue';
import * as tools from '../../../../utils/roulink';
import GoLogin from '../../../common/mobile/goLogin.vue'; //登录提示框

export default {
  name: '',
  components: { MobileHead, Foot, GoLogin },
  data() {
    return {
      baseUrl: forMat(),
      activeName: 'first',
      // 直播返回数据
      liveDate: [],
      total1: 1,
      pageshow: true,
      isBackground: true,
      currentPage4: 1, //分页当前页
      visible: false, //弹框可见
      // 二维码图片
      livePhoto: '',
      // 直播请求数据
      liveForm: {
        pageNo: 1,
        pageSize: 12,
        keyword: '',
        date: '10月25日',
      },
      tagData: this.$t('live.tab1'),
      dialogVisible: false,
    };
  },
  created() {
    this.getLive();
    document.documentElement.scrollTop = 0;
  },
  methods: {
    // 请求数据
    // async getLive() {
    //   const datas = await getLiveInfo(this.liveForm);
    //   this.liveDate = datas.data.data.list;
    //   this.total1 = datas.data.data.count;
    // },
    async getLive() {
      const datas = await getLiveInfo(this.liveForm);
      this.total1 = datas.data.data.count;
      let array = datas.data.data.list;
      // 临时需求：直播 10月25日 将两个展会直播放到最前
      if (this.liveForm.date == "10月25日") {
        array.map((item, index) => {
          if (item.id == "1eec09c9ba03402ba6bbea4b35e2d8a9") {
            array.unshift(array.splice(index, 1)[0]);
          }
          if (item.id == "475c5715463c47e4a91dc125d8aa8f56") {
            array.unshift(array.splice(index, 1)[0]);
          }
        });
      }
      this.liveDate = array;
    },
    //标签切换事件
    handleClick(tab, event) {
      if (tab.label == this.$t('live.tab1')) {
        this.tagData = '10月25日';
      } else if (tab.label == this.$t('live.tab2')) {
        this.tagData = '10月26日';
      } else if (tab.label == this.$t('live.tab3')) {
        this.tagData = '10月27日';
      } else if (tab.label == this.$t('live.tab4')) {
        this.tagData = '10月28日';
      }
      this.liveForm = {
        pageNo: 1,
        pageSize: 12,
        date: this.tagData,
      };
      this.getLive();
    },
    //分页点击事件
    handleCurrentChange(val) {
      this.liveForm = {
        pageNo: val,
        pageSize: 12,
        keyword: this.input,
        date: this.tagData,
      };
      this.getLive();
      console.log(`当前页: ${val}`);
    },
    //关闭弹窗
    close() {
      this.visible = false;
    },
    //判断点击收藏状态
    async toggle(item) {
      const shouDetail = {
        objId: item.id,
        flag: !item.collectStatus,
        type: 3,
      };
      try {
        const data = await getShoucang(shouDetail);
        if (data.data.code === 200) {
          item.collectStatus = !item.collectStatus;
          if (item.collectStatus) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          // tools.login(3);
        }
      } catch (err) {
        if (err == 'noLogin') {
          this.dialogVisible = true;
        }
        console.log(err);
      }
    },
    // 点击跳转直播详情
    liveDetail(item) {
      if (item.videoType == 1) {
        this.$router.push({ name: 'live_detail', query: { userId: item.id } });
      } else if (item.videoType == 2) {
        window.open(item.videoAddress);
      } else if (item.videoType == 3) {
        this.visible = true;
        this.livePhoto = item.videoAddress;
      }
    },
    getMsgFormSon(data) {
      this.dialogVisible = data;
      tools.login(3);
    },
    getCancel(data) {
      this.dialogVisible = data;
    },
  },
};
</script>

<style scoped lang="scss">
.liveItem {
  margin-top: 13.3vw;
  .liveContent {
    .main {
      padding-top: 23px;
      box-sizing: border-box;
      margin: 0 auto;
      padding-left: 4vw;
      box-sizing: border-box;
      .breadcrumb {
        a {
          color: #006fb8;
        }
      }
      .search {
        margin-top: 8.3vw;
        font-size: 4.8vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
    .tab {
      position: relative;
      .el-tabs__header {
        margin: 0 !important;
      }
      .live-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-left: 4vw;
        padding-right: 4vw;
        box-sizing: border-box;
        .item {
          width: 47%;
          // height: 56.8vw;
          margin-top: 4vw;
          border: 1px solid #e0e0e0;
          .vedio {
            width: 100%;
            height: 26.7vw;
            position: relative;
            .shoucang {
              position: absolute;
              z-index: 99;
              right: 1.3vw;
              top: 1.3vw;
              width: 6vw;
              height: 6vw;
            }
            .fengmian {
              width: 100%;
              height: 100%;
            }
            .fixed {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              background-color: rgba(30, 30, 30, 0.3);
              display: none;
              img {
                // margin: 88px 176px;
                width: 7vw;
                height: 8.6vw;
                margin: 9.47vw 23.3vw 12.1vw;
              }
            }
          }
          .vedio:hover > .fixed {
            display: block;
          }

          .title {
            box-sizing: border-box;
            height: 20.53vw;
            padding: 2.6vw;
            p {
              padding-bottom: 2.6vw;
              font-size: 3.7vw;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              word-break: break-all;
            }
            .title_icon {
              margin: 0 auto;
              margin-top: 4vw;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              line-height: 3vw;
              color: #666;
              font-family: Microsoft YaHei;
              font-weight: 400;
              .img {
                width: 3vw;
                height: 3vw;
                img {
                  width: 3vw;
                  height: 3vw;
                }
              }
              span {
                margin-left: 1.6vw;
                font-size: 3vw;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666;
                line-height: 3vw;
                height: 3vw;
              }
            }
          }
          .down {
            border-top: 1px #e0e0e0 solid;
            height: 9.3vw;
            p {
              font-size: 2.6vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 9.3vw;
              margin-left: 2.6vw;
              color: #999999;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              word-break: break-all;
            }
          }
        }
      }
      .live-box .item:nth-child(2n) {
        margin-right: 0;
      }
      .pagination {
        display: flex;
        justify-content: center;
        margin: 2.6vw 0 8vw;
        span {
          font-size: 1.6vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin-top: 1.2vw;
        }
      }
      .alert_mess {
        width: 100vw;
        height: 100vh;
        box-sizing: border-box;
        text-align: center;
        background: white;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        margin: auto;
        z-index: 999;
        justify-content: center;
        align-items: center;
        padding: 4vw;
        padding-top: 20vw;
        display: flex;
        .close {
          width: 3.2vw !important;
          height: 3.2vw !important;
          position: absolute;
          right: 10vw;
          top: 20vw;
          float: right;
        }

        .qrcode {
          justify-content: center;
          align-items: center;
          display: flex;
          margin: 0 auto;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          -webkit-transform: translate3d(-50%, -50%, 0);
          img {
            width: auto;
            height: auto;
            max-width: 90%;
            max-height: 90%;
          }
        }
        .tip {
          font-size: 4.3vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          position: absolute;
          bottom: 30vw;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.el-dialog {
  text-align: center;
}
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
    vertical-align: middle;
    min-width: 5.3vw;
    padding: 0;
    box-sizing: border-box;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw;
    color: #333;
    font-size: 2.1vw;
    background: #fff;
    border-radius: 0.5vw;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 0.7vw;
    margin-left: 1.3vw;
  }

  .btn-next {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw;
    color: #333;
    font-size: 2.1vw;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 0.7vw;
  }
  .el-pager .number {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw !important;
    border-radius: 0.5vw;
    border: 1px solid #cccccc;
    margin-right: 1vw;
    color: #333;
    font-size: 2.1vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    background: #fff;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw !important;
    border: 1px solid #007cc2;
    cursor: pointer;
    background: #006fb8 !important;
    font-size: 2.1vw;
    font-weight: 400;
    color: #fff;
    font-family: Microsoft YaHei;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 3.7vw;
    color: #999;
  }
}
</style>
<style scoped>
.el-pagination >>> button {
  min-width: 5.3vw !important;
}
.pagination >>> .el-icon-arrow-right,
.pagination >>> .el-icon-arrow-left {
  color: #333;
}
.tab >>> .el-tabs__nav-wrap::after {
  background: white;
  position: static !important;
  height: 0;
}
.tab >>> .el-tabs__nav-scroll {
  padding-left: 4vw;
  padding-right: 4vw;
  box-sizing: border-box;
}
.tab >>> .el-tabs__item {
  padding: 0 4vw;
  box-sizing: border-box;
}

.tab >>> .el-tabs__nav-scroll {
  padding-left: 4vw;
  padding-right: 4vw;
  box-sizing: border-box;
  widows: 100%;
  overflow-x: scroll;
}
.el-tabs--top >>> .el-tabs__item.is-top:last-child{
  margin-right: 4vw;
}
.tab >>> .el-tabs__nav-scroll::-webkit-scrollbar {
  display: none;
}
.tab >>> .el-tabs__active-bar {
  height: 0.7vw;
  background-color: #006fb8;
}
.tab >>> .el-tabs__item.is-active {
  color: #006fb8;
}
.breadcrumb >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #006fb8 !important;
  font-family: Microsoft YaHei;
}
.pagination >>> .el-icon-arrow-right {
  vertical-align: middle !important;
  justify-content: center;
  align-items: center;
  display: flex;
}
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  color: #333 !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
</style>
